// Human-readable comparison phrasing for the % changes across the dashboard.
// We describe the comparison in WORDS (e.g. "vs. prior 3 months", "vs. prior
// year") rather than raw dates, and keep the exact mm/dd/yy range available for
// the hover title.

// Turn a window [start, end) into a plain phrase: "3 months", "6 weeks", "1 year"…
export function windowPhrase(startIso, endIso) {
  if (!startIso || !endIso) return "period";
  const s = new Date(`${startIso}T00:00:00`);
  const e = new Date(`${endIso}T00:00:00`);
  const days = Math.round((e - s) / 86400000);
  if (days <= 0) return "period";
  if (days >= 360 && days <= 372) return "year";
  const months = Math.round(days / 30.44);
  if (months >= 1 && Math.abs(days - months * 30.44) <= 3) return months === 1 ? "month" : `${months} months`;
  const weeks = Math.round(days / 7);
  if (weeks >= 1 && Math.abs(days - weeks * 7) <= 1) return weeks === 1 ? "week" : `${weeks} weeks`;
  return days === 1 ? "day" : `${days} days`;
}

// Map a backend comparison label → comparison kind. "Prior period" (no year)
// is the immediately-prior window; anything with "year"/"dates" is a YoY view.
export function compareKind(label = "") {
  const l = String(label).toLowerCase();
  if (l.includes("dates")) return "same_dates";
  if (l.includes("year")) return "same_period";
  return "prior";
}

// Words for a comparison. `kind` is "prior" | "same_period" | "same_dates".
export function comparePhrase(kind, startIso, endIso) {
  if (kind === "same_dates") return "vs. same dates, prior year";
  if (kind === "same_period") return "vs. prior year";
  return `vs. prior ${windowPhrase(startIso, endIso)}`;
}
